import { render, staticRenderFns } from "./ClientsForm.vue?vue&type=template&id=72e59946"
import script from "./ClientsForm.vue?vue&type=script&lang=js"
export * from "./ClientsForm.vue?vue&type=script&lang=js"
import style0 from "./ClientsForm.vue?vue&type=style&index=0&id=72e59946&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports